// Google token
export const GOOGLE_VERIFY_TOKEN = 'google-verify-token';
export const GOOGLE_VERIFY_TOKEN_ERROR = 'google-verify-token-error';
export const GOOGLE_VERIFY_TOKEN_SUCCESS = 'google-verify-token-success';
export const GOOGLE_VERIFY_TOKEN_RESET = 'google-verify-token-reset';

export const LOGIN_USER_SUCCESS = 'account/login-user-success';